import { FC } from 'react';

import styles from './Progressive.module.scss';

type ProgressiveParams = {
  progress: number;
};

export const Progressive: FC<ProgressiveParams> = ({ progress }) => {
  return (
    <div className={styles.progressive}>
      <div id="stars" className={styles.starts}>
        <div className={styles.star1}>
          <svg
            id="star1"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0L9.47078 6.52922L16 8L9.47078 9.47078L8  16L6.52922 9.47078L0 8L6.52922 6.52922L8 0Z"
              fill="white"
            />
          </svg>
        </div>
        <div className={styles.star2}>
          <svg
            id="star2"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0L9.47078 6.52922L16 8L9.47078 9.47078L8  16L6.52922 9.47078L0 8L6.52922 6.52922L8 0Z"
              fill="white"
            />
          </svg>
        </div>
        <div className={styles.star3}>
          <svg
            id="star3"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0L9.47078 6.52922L16 8L9.47078 9.47078L8  16L6.52922 9.47078L0 8L6.52922 6.52922L8 0Z"
              fill="white"
            />
          </svg>
        </div>
        <div className={styles.book}>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_496_2377)">
              <path
                d="M23.9996 32.3998C20.6531 30.9033 16.4435 30.0862 12.0996 30.0899C9.91001 30.0899 7.81561 30.2932 5.86628 30.6655C5.6097 30.7146 5.3351 30.7296 5.06555 30.7093C4.79601 30.6891 4.53939 30.6342 4.31729 30.5492C4.09518 30.4642 3.91407 30.3517 3.78919 30.221C3.6643 30.0904 3.59929 29.9454 3.59961 29.7984V12.3455C3.59966 12.1555 3.70867 11.9703 3.91164 11.8152C4.1146 11.6601 4.40154 11.5429 4.73295 11.4796C7.09912 11.0283 9.59039 10.7984 12.0996 10.7998C16.3173 10.7964 20.448 11.4482 23.9996 12.6774C27.5512 11.4482 31.6819 10.7964 35.8996 10.7998C38.4088 10.7984 40.9001 11.0283 43.2663 11.4796C43.5977 11.5429 43.8846 11.6601 44.0876 11.8152C44.2905 11.9703 44.3996 12.1555 44.3996 12.3455V29.7984C44.3999 29.9454 44.3349 30.0904 44.21 30.221C44.0851 30.3517 43.904 30.4642 43.6819 30.5492C43.4598 30.6342 43.2032 30.6891 42.9337 30.7093C42.6641 30.7296 42.3895 30.7146 42.1329 30.6655C40.1836 30.2932 38.0892 30.0899 35.8996 30.0899C31.5557 30.0862 27.3461 30.9033 23.9996 32.3998Z"
                fill="#A9957D"
              />
              <path
                d="M23.1878 9.24511C20.1954 8.03709 16.715 7.3966 13.1613 7.39992C11.0471 7.39855 8.94807 7.62447 6.95442 8.06794C6.67519 8.13016 6.43342 8.2454 6.26241 8.3978C6.0914 8.5502 5.99955 8.73226 5.99951 8.91892V26.0709C5.99954 26.2153 6.05455 26.3576 6.1599 26.4859C6.26526 26.6141 6.41789 26.7246 6.60498 26.8079C6.79208 26.8913 7.00818 26.9452 7.23514 26.965C7.4621 26.9848 7.6933 26.9701 7.90933 26.9219C9.59633 26.5469 11.3725 26.356 13.1613 26.3574C16.9714 26.3574 20.4625 27.2084 23.1878 28.6275V9.24511ZM24.8112 28.6275C27.6308 27.1568 31.1777 26.3538 34.8377 26.3574C36.6826 26.3574 38.4473 26.5572 40.0897 26.9231C40.3059 26.9713 40.5373 26.986 40.7644 26.9662C40.9915 26.9463 41.2077 26.8923 41.3948 26.8088C41.582 26.7253 41.7346 26.6147 41.8398 26.4863C41.945 26.3579 41.9998 26.2154 41.9995 26.0709V8.91892C41.9995 8.73226 41.9076 8.5502 41.7366 8.3978C41.5656 8.2454 41.3238 8.13016 41.0446 8.06794C39.051 7.62447 36.9519 7.39855 34.8377 7.39992C31.284 7.3966 27.8037 8.03709 24.8112 9.24511V28.6275Z"
                fill="white"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_496_2377"
                x="2.59961"
                y="7.3999"
                width="42.7998"
                height="27"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="0.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_496_2377"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_496_2377"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>

      <progress className={styles.progress} max="100" value={progress}></progress>
    </div>
  );
};
